import script from "./ResourceCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResourceCard.vue?vue&type=script&setup=true&lang=ts"

import "./ResourceCard.vue?vue&type=style&index=0&id=1bdd7e19&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bdd7e19"]])

export default __exports__